import { TwoColumnTasksInboxView } from '@/components/tasks/two-column-tasks-inbox-view';
import { createFileRoute } from '@tanstack/react-router';
import { useUserProfile } from '@/contexts/user.context';
import { UserRole } from '@/lib/types';
import { Suspense, lazy } from 'react';
import { useAllActionLogsQuery } from '@/lib/query-options';
import { useAtomValue } from 'jotai';
import { organizationDataAtom } from '@/store';

// Lazy load the admin panel to prevent it from being bundled with the rest of the app
const AdminRecommendationPanel = lazy(() =>
  import('@/components/tasks/admin-recommendation-panel').then((module) => ({
    default: module.AdminRecommendationPanel,
  })),
);

export const Route = createFileRoute('/_authenticated/_layout/tasks/_layout/new')({
  component: NewTasks,
});

function NewTasks() {
  const { user } = useUserProfile();
  const isAdmin = user && user.role === UserRole.ADMIN;

  return (
    <div className='pt-6 space-y-6'>
      {isAdmin && (
        <Suspense fallback={<div>Loading admin tools...</div>}>
          <AdminRecommendationPanel />
        </Suspense>
      )}
      <TasksInboxWrapper />
    </div>
  );
}

// Wrapper component that only renders when we have actions
function TasksInboxWrapper() {
  const organizationData = useAtomValue(organizationDataAtom);
  const { data, isLoading } = useAllActionLogsQuery(
    { is_undone: false, organization_id: organizationData?.id },
    { skip: 0, limit: 20 }
  );

  // If there's no data or it's empty, don't render anything
  if ((!data?.items || data.items.length === 0) && !isLoading) {
    return null;
  }

  return <TwoColumnTasksInboxView />;
}
